import * as React from "react";
import { LoginComp } from "../../components/Login";

export const LoginScene: React.FC = (): JSX.Element => <LoginComp />;
